import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import { VueAxios } from '@/utils/request'


import config from '@/config'
import utils from '@/utils'

Vue.config.productionTip = false
Vue.use(VueAxios)
Vue.use(utils)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
